// extracted by mini-css-extract-plugin
export default {"resetButton":"OeJmkwU","root":"zkrFQBX","closeButton":"iHBUgFY","header":"HX49E0U","shortcut":"kJcMqhH"};